
export default {
  init() {
    const primaryHero = (function () {
      const $primaryHeroEls = $('.block-primary-hero');

      const handleLoad = function () {
        setTimeout(function () {
          if ($primaryHeroEls.length) {
            $primaryHeroEls.each(function (i, el) {
              $(el).addClass('loaded');
            });
          }
        }, 200);
      };

      const run = function () {
        handleLoad();
      };

      return { run };
    })();

    $(function () {
      primaryHero.run();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/blocks/primaryHero.js